/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Coaches_Empty_TitleInputs */

const en_portal_coaches_empty_title = /** @type {(inputs: Portal_Coaches_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaches' calendars open here`)
};

const pl_portal_coaches_empty_title = /** @type {(inputs: Portal_Coaches_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu otwierają się kalendarze trenerów`)
};

/**
* | output |
* | --- |
* | "Coaches' calendars open here" |
*
* @param {Portal_Coaches_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_coaches_empty_title = /** @type {((inputs?: Portal_Coaches_Empty_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Coaches_Empty_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_coaches_empty_title(inputs)
	return en_portal_coaches_empty_title(inputs)
});